(() => {
  const storeDetails = JSON.parse(
    document.querySelector('[data-stores="all-details"]').textContent
  )?.stores;
  const searchInput = document.querySelector('[data-asset="search-input"]');
  const addressList = document.querySelector('[data-asset="address-list"]');
  const radiusInput = document.querySelector('[data-asset="radius-selector"]');
  const storeSearchForm = document.querySelector("#store-search-form");
  const searchResult = document.querySelector('[data-asset="search-result"]');

  const localeDataElement = document.getElementById("locale-store-locator");
  const locale = JSON.parse(localeDataElement.textContent);

  const market = window.currentMarket;
  const storeDisplayDrawerId = "StoreDisplayDrawer-visit";
  let center;
  let country;
  let unitConversion;

    if (market === 'GB') {
        country = 'UK';
        center = { lat: 53.0432062, lng: -2.1090424 };
        unitConversion = 0.000621371192;
    } else if (market === 'GERMANY' || market === 'DE' || market === 'AUSTRIA' || market === 'AT' || market === 'SWITZERLAND' || market === 'CH') {
        country = 'DE';
        center = { lat: 51.1657, lng: 10.4515 };
        unitConversion = 0.001;
    }
    const zoomScale = 7;
    const SWYFT_PIN_ICON = "https://cdn.shopify.com/s/files/1/0875/6599/2271/files/swyft-map-icon-dark.png?v=1784131911";
    const PARTNER_PIN_ICON = "https://cdn.shopify.com/s/files/1/0052/8770/6673/files/swyft-map-icon-compressed.png?v=1662471346";
    const createdAdvancedMarkers = [];
    let map = null;
    let searchedPlace = null;

  async function initMap() {
    // Request needed libraries.
    await google.maps.importLibrary("marker");
    await google.maps.importLibrary("places");
    await google.maps.importLibrary("maps");
    await google.maps.importLibrary("geometry");

    map = new google.maps.Map(document.getElementById("map"), {
      zoom: zoomScale,
      center,
      mapId: "4cd1405ca8046ae",
    });

    await initMakers();
    listAllStoresInitially();
    await initializeAutocomplete();
  }

  async function initMakers() {
    let index = 0;
    for (const storeDetail of storeDetails) {
      const storeDetailWrapper = buildContent(storeDetail, index);
      const AdvancedMarkerElement =
        new google.maps.marker.AdvancedMarkerElement({
          map,
          content: storeDetailWrapper,
          position: storeDetail.position,
          title: storeDetail.description,
        });

      AdvancedMarkerElement.addListener("click", ({ domEvent }) => {
        const link = domEvent && domEvent.target.closest("a");
        if (link && link.href) {
          window.open(link.href, link.target || "_self");
          return;
        }
        toggleHighlight(AdvancedMarkerElement);
      });

      createdAdvancedMarkers.push(AdvancedMarkerElement);
      index++;
    }
    radiusInput.addEventListener("change", function () {
      searchNearestStores();
    });
    storeSearchForm.addEventListener("submit", function (event) {
      event.preventDefault();
      event.stopPropagation();
      searchNearestStores();
    });
  }

  function listAllStoresInitially() {
    let storeDetailsHtml = "";
    for (const marker of createdAdvancedMarkers) {
      marker.content.classList.remove("hide");
      storeDetailsHtml += marker.content.outerHTML;
    }
    addressList.innerHTML = storeDetailsHtml;
    registerDrawerTriggers();

    setTimeout(() => {
      initEventsOnStoreDetail();
    }, 50);
  }

  async function initEventsOnStoreDetail() {
    const storeDetailsElements = document.querySelectorAll(
      '[data-asset="address-list"] .store-detail'
    );
    storeDetailsElements.forEach((element) => {
      element.addEventListener("click", function (event) {
        const elementIndex = event.currentTarget.getAttribute("data-index");
        toggleHighlight(createdAdvancedMarkers[elementIndex]);
      });
    });
  }

  async function initializeAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(searchInput);
    autocomplete.setComponentRestrictions({
      country: [country],
    });
    autocomplete.addListener("place_changed", () => {
      searchedPlace = autocomplete.getPlace();
      if (!searchedPlace.geometry || !searchedPlace.geometry.location) {
        console.log("Place details not found!");
        return;
      }
      searchNearestStores();
    });
  }

  function searchNearestStores() {
    if (!searchInput.value) return;

    const searchedPlacePosition = searchedPlace?.geometry?.location;
    const bounds = new google.maps.LatLngBounds();
    const radius = Number(radiusInput.value);
    let totalStoresFound = 0;

    const processMarkers = (position) => {
      const markersWithDistances = createdAdvancedMarkers.map((marker) => {
        const distance =
          google.maps.geometry.spherical.computeDistanceBetween(
            position,
            marker.position
          ) * unitConversion;

        return {
          marker,
          distance,
        };
      });
      markersWithDistances.sort((a, b) => a.distance - b.distance);

      let storeDetailsHtml = "";
      markersWithDistances.forEach(({ marker, distance }) => {
        let distanceInnerHtml;
        distanceInnerHtml = `<span class="distance-title">${
          locale.address.label
        }</span><span class="distance-value">${distance.toFixed(2)} ${
          locale.address.value
        }</span>`;
        if (distance <= radius) {
          totalStoresFound++;
          marker.content.querySelector("[data-distance]").innerHTML =
            distanceInnerHtml;
          marker.content.classList.remove("hide");
          storeDetailsHtml += marker.content.outerHTML;
          bounds.extend(marker.position);
        } else {
          marker.content.classList.add("hide");
        }
      });
      addressList.innerHTML = storeDetailsHtml;
      registerDrawerTriggers();
      setTimeout(() => {
        initEventsOnStoreDetail();
      }, 50);

      showMessage(totalStoresFound, radius, bounds);
    };

    if (searchedPlacePosition) {
      processMarkers(searchedPlacePosition);
      searchedPlace = null;
    } else {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: searchInput.value }, (results, status) => {
        if (status === "OK") {
          processMarkers(results[0].geometry.location);
        } else {
          showMessage(null, null, null);
        }
      });
    }
  }

  function registerDrawerTriggers() {
    const attach = () => {
      const drawer = document.getElementById(storeDisplayDrawerId);
      if (drawer && typeof drawer.registerTriggers === "function") {
        drawer.registerTriggers();
      }
    };

    if (window.customElements && typeof window.customElements.whenDefined === "function") {
      window.customElements.whenDefined("store-display-drawer").then(attach);
    } else {
      attach();
    }
  }

  function showMessage(totalStoresFound, radius, bounds) {
    if (totalStoresFound > 0) {
      map.fitBounds(bounds);
      searchResult.innerHTML = `<p class="message">${totalStoresFound} ${locale.alert.store_found_title} ${radius} ${locale.address.value}.</p>`;
      addressList.classList.remove("no-stores");

    } else if (totalStoresFound == 0) {
      searchResult.innerHTML = `<p class="message">${locale.alert.store_not_found_in_limit_message} ${radius} ${locale.address.value} ${locale.alert.store_not_found_in_limit_message_2}</p>`;
      addressList.classList.add("no-stores");
    } else {
      searchResult.innerHTML = `<p class="message">${locale.alert.store_not_found_message}</p>`;
      addressList.classList.add("no-stores");
    }
  }

  // The open store box must sit above every pin. Markers without a zIndex are stacked by latitude, so a box opened
  // for a London store sat under the London cluster; the reset loop also cleared the clicked marker instead of the others.
  const HIGHLIGHT_Z_INDEX = 1000;
  function toggleHighlight(markerView) {
    if (markerView.content.classList.contains("highlight")) {
      markerView.content.classList.remove("highlight");
      markerView.zIndex = null;
    } else {
      createdAdvancedMarkers.forEach((createdAdvancedMarker) => {
        createdAdvancedMarker.content.classList.remove("highlight");
        createdAdvancedMarker.zIndex = null;
      });
      markerView.content.classList.add("highlight");
      markerView.zIndex = HIGHLIGHT_Z_INDEX;
    }
  }

  function decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  function buildContent(storeDetail, index) {
    const content = document.createElement("div");
    content.classList.add("store-detail");
    content.classList.add("hide");
    content.setAttribute("data-index", index);

    // Swyft-owned stores link to a swyfthome.* domain; partners link to their own external site
    const isSwyftStore = /swyfthome\./i.test(storeDetail.website_link || "");
    content.classList.add(isSwyftStore ? "store-detail--swyft" : "store-detail--partner");
    // A store's own "Pin colour" wins, so a partner can carry the Swyft pin (Swyft x Basus Home).
    const pinColour = (storeDetail.pin_colour || "").trim();
    const darkPin = pinColour === "black" || (pinColour !== "orange" && isSwyftStore);
    const iconUrl = darkPin ? SWYFT_PIN_ICON : PARTNER_PIN_ICON;

    if (storeDetail.sort_order != '') {
      content.setAttribute("style", `order:${storeDetail.sort_order};`);
    }

    const isOnDisplay =
      storeDetail.on_display === true || storeDetail.on_display === 'true';
    const onDisplayMarkup = isOnDisplay
      ? `<div class="product-showcase">
            <a class="store-detail__on-display-link"
               href="#"
               data-store-display-trigger="${storeDisplayDrawerId}"
               data-store-handle="${storeDetail.handle || ''}"
               aria-controls="${storeDisplayDrawerId}"
               role="button">${decodeHtml(locale.product.on_display_label)}</a>
          </div>`
      : '';

    content.innerHTML = `
            <div class="icon">
                <img src="${iconUrl}" alt="${
                  storeDetail.name
                }" width="25" height="35"/>
            </div>
            <div class="icon-close">
                <svg height="15" width="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g stroke-width="0"></g>
                    <g stroke-linecap="round" stroke-linejoin="round"></g>
                    <g>
                        <rect width="24" height="24" fill="#e57f6b"></rect>
                        <path d="M7 17L16.8995 7.10051" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M7 7.00001L16.8995 16.8995" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path>
                    </g>
                </svg>
            </div>
            <div class="details">
                <div class="name">${storeDetail.name}</div>
                <div class="name_subtitle">${storeDetail.name_subtitle || ''}</div>
                <div class="address">${storeDetail.address}</div>
                <div class="distance" data-distance></div>
                ${
                  storeDetail.opening_times &&
                  `<div class="availability">
                        <div class="availability-title">${
                          locale.store.store_info
                        }</div>
                        <div class="days-availability">
                            ${
                              storeDetail.opening_times.monday &&
                              `<span>${locale.days.monday}</span><span>${storeDetail.opening_times.monday}</span>`
                            }
                            ${
                              storeDetail.opening_times.tuesday &&
                              `<span>${locale.days.tuesday}</span><span>${storeDetail.opening_times.tuesday}</span>`
                            }
                            ${
                              storeDetail.opening_times.wednesday &&
                              `<span>${locale.days.wednesday}</span><span>${storeDetail.opening_times.wednesday}</span>`
                            }
                            ${
                              storeDetail.opening_times.thursday &&
                              `<span>${locale.days.thursday}</span><span>${storeDetail.opening_times.thursday}</span>`
                            }
                            ${
                              storeDetail.opening_times.friday &&
                              `<span>${locale.days.friday}</span><span>${storeDetail.opening_times.friday}</span>`
                            }
                            ${
                              storeDetail.opening_times.saturday &&
                              `<span>${locale.days.saturday}</span><span>${storeDetail.opening_times.saturday}</span>`
                            }
                            ${
                              storeDetail.opening_times.sunday &&
                              `<span>${locale.days.sunday}</span><span>${storeDetail.opening_times.sunday}</span>`
                            }
                        </div>
                         ${
                           storeDetail.notes &&
                           `<span class="store-notes"></span>`
                         }
                    </div>`
                }
                <div class="contacts">
                    ${
                      storeDetail.phone_number &&
                      `<div class="contact">
                            <span class="contact-icon">
                                <svg height="15" width="15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000">
                                    <g stroke-width="0"></g>
                                    <g stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g>
                                        <g>
                                            <path style="fill:#65C6BB;" d="M219.38,464.937L47.062,292.616c-45.996-45.993-59.669-114.56-34.831-174.68l30.906-74.813 c17.953-43.459,74.371-54.673,107.59-21.455l34.809,34.81c18.703,18.703,24.423,46.649,14.573,71.197l-14.965,37.292 c-4.26,10.612-1.787,22.694,6.299,30.78l124.807,124.807c8.086,8.087,20.166,10.557,30.779,6.3l37.292-14.965 c24.55-9.851,52.496-4.132,71.198,14.572l34.809,34.809c33.249,33.247,21.966,89.653-21.453,107.591l-74.813,30.906 C333.956,524.597,265.393,510.948,219.38,464.937z"></path>
                                            <path style="fill:#65C6BB;" d="M468.685,248.546C501.879,124.2,387.902,10.092,263.455,43.313 c-23.892,6.384-33.588-29.785-9.657-36.173c152.165-40.629,291.72,98.757,251.06,251.062 C498.439,282.254,462.278,272.548,468.685,248.546z"></path>
                                            <path style="fill:#65C6BB;" d="M373.143,223.037c13.642-51.095-33.065-97.829-84.182-84.183 c-23.896,6.375-33.588-29.784-9.657-36.174c78.892-21.057,151.098,51.042,130.013,130.015 C402.893,256.748,366.735,247.038,373.143,223.037z"></path>
                                        </g>
                                        <g>
                                            <path style="fill:#20B8AE;" d="M490.327,361.271l-34.809-34.809c-18.703-18.704-46.649-24.423-71.198-14.572l-37.292,14.965 c-10.613,4.257-22.694,1.787-30.779-6.3l-63.051-63.051L132.572,378.128l86.806,86.807c46.013,46.012,114.576,59.66,174.681,34.831 l74.813-30.906C512.293,450.924,523.574,394.517,490.327,361.271z"></path>
                                            <path style="fill:#20B8AE;" d="M504.858,258.202c20.418-76.479-4.615-149.692-53.858-198.499l-26.487,26.487 c40.34,39.919,60.861,99.839,44.173,162.355C462.278,272.548,498.44,282.254,504.858,258.202z"></path>
                                            <path style="fill:#20B8AE;" d="M409.315,232.696c10.632-39.819-2.461-77.883-28.163-103.147l-26.488,26.488c16.795,16.363,25.39,41.114,18.477,67.001C366.735,247.038,402.893,256.748,409.315,232.696z"></path>
                                        </g>
                                    </g>
                                </svg>
                            </span>
                            <a href="tel:${storeDetail.phone_number}" target="_blank">
                                <span style="color:#20B8AE;">${storeDetail.phone_number}</span>
                            </a>
                        </div>`
                    }
                    ${
                      storeDetail.email &&
                      `<div class="contact">
                            <span class="contact-icon">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="#e57f6b" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 4h20v16H2V4zm2 2v12h16V6H4zm8 5.5L4.5 6.5l1.41-1.41L12 10.09l6.09-5.01L19.5 6.5 12 11.5z"/>
                                </svg>
                            </span>
                            <a href="mailto:${storeDetail.email}"><span style="color:#e57f6b;">${storeDetail.email}</span></a>
                        </div>`
                    }
                    ${
                      storeDetail.website_link &&
                      `<div class="contact">
                            <span class="contact-icon">
                                <svg height="15" width="15" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#558B2F">
                                    <g stroke-width="0"></g>
                                    <g stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g>
                                        <path fill="#558B2F" d="M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"></path>
                                    </g>
                                </svg>
                            </span>
                            <a href="${storeDetail.website_link}" target="_blank"><span style="color:#558B2F;">${locale.store.store_redirect_label}</span></a>
                        </div>`
                    }
                </div>
                ${
                  storeDetail.models_on_display && (
                  `<div class="product-showcase">
                        <div class="showcase-title">${locale.product.info_label}</div>
                        <p>
                            ${storeDetail.models_on_display}
                        </p>
                    </div>`
                )}
                ${onDisplayMarkup}

            </div>
            `;
    if (storeDetail.notes) {
      const notesEl = content.querySelector(".store-notes");
      if (notesEl) {
        notesEl.innerHTML = decodeHtml(storeDetail.notes); // This will render HTML
      }
    }
    return content;
  }

  initMap();
})();
